import { render } from "./dictionaries.vue?vue&type=template&id=4be2002d&scoped=true"
import script from "./dictionaries.vue?vue&type=script&lang=js"
export * from "./dictionaries.vue?vue&type=script&lang=js"

import "./dictionaries.vue?vue&type=style&index=0&id=4be2002d&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be2002d"]])

export default __exports__